import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import '../Assets/Css/product.css';
import productbanner from '../Assets/Images/productss.avif';
import { FaGem, FaShieldAlt, FaCogs,FaIndustry, FaTruck, FaHandsHelping } from 'react-icons/fa';

import product1 from '../Assets/Images/Hygienic Stainless Steel Fittings.png'
import product2 from '../Assets/Images/Stainless Steel Strainers  Mesh.png'
import product3 from '../Assets/Images/Motion Load Handling Components.png'
import product4 from '../Assets/Images/Caster Wheels.png'

import pharmaImg from '../Assets/Images/pharma.png';
import foodImg from '../Assets/Images/food.png';
import dairyImg from '../Assets/Images/dairy.png';
import automationImg from '../Assets/Images/automation.png';

import steelfitting1 from '../Assets/Images/steelfitting1.png'
import steelfitting2 from '../Assets/Images/steelfitting2.png'
import steelfitting3 from '../Assets/Images/steelfitting3.png'
import steelfitting4 from '../Assets/Images/steelfitting4.png'

import mesh1 from '../Assets/Images/Mesh1.png'
import mesh2 from '../Assets/Images/Mesh2.png'
import mesh3 from '../Assets/Images/Mesh3.png'
import mesh4 from '../Assets/Images/Mesh4.png'

import wheel1 from '../Assets/Images/casterwheel1.png'
import wheel2 from '../Assets/Images/casterwheel2.png'
import wheel3 from '../Assets/Images/casterwheel3.png'
import wheel4 from '../Assets/Images/casterwheel4.png'


import motionload1 from '../Assets/Images/Motion & Load 1.png'
import motionload2 from '../Assets/Images/Motion & Load 2.png'
import motionload3 from '../Assets/Images/Motion & Load 3.png'
import motionload4 from '../Assets/Images/Motion & Load 4.png'

import { Helmet } from "react-helmet";


import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import img1 from "../Assets/Images/Productrange1.png";
import img2 from "../Assets/Images/Productrange2.png";
import img3 from "../Assets/Images/Productrange3.png";
import img4 from "../Assets/Images/Productrange4.png";
import img5 from "../Assets/Images/Productrange5.png";
import img6 from "../Assets/Images/Productrange6.png";
import img7 from "../Assets/Images/Productrange7.png";
import img8 from "../Assets/Images/Productrange8.png";
import img9 from "../Assets/Images/Productrange9.png";
import img10 from "../Assets/Images/Productrange10.png";
import img11 from "../Assets/Images/Productrange11.png";
import img12 from "../Assets/Images/Productrange12.png";
import img13 from "../Assets/Images/Productrange13.png";
import img14 from "../Assets/Images/Productrange14.png";
import img15 from "../Assets/Images/Productrange15.png";
import img16 from "../Assets/Images/Productrange16.png";
import img17 from "../Assets/Images/Productrange17.png";
import img18 from "../Assets/Images/Productrange18.png";
import img19 from "../Assets/Images/Productrange19.png";
import img20 from "../Assets/Images/Productrange20.png";
import img21 from "../Assets/Images/Productrange21.png";
import img22 from "../Assets/Images/Productrange22.png";
import img23 from "../Assets/Images/Productrange23.png";
import img24 from "../Assets/Images/Productrange24.png";
import img25 from "../Assets/Images/Productrange25.png";
import img26 from "../Assets/Images/Productrange26.png";
import img27 from "../Assets/Images/Productrange27.png";
import img28 from "../Assets/Images/Productrange28.png";
import img29 from "../Assets/Images/Productrange29.png";



const sections = [
  {
    title: 'Hygienic Stainless Steel Fittings',
    desc: (
      <>
        <Card.Text>
          Engineered for clean-in-place (CIP) and sanitary applications, our stainless steel fittings are designed to prevent contamination and maintain flow efficiency across processing lines.
        </Card.Text>
        <ul className="mb-0">
          <li><strong>S.S. TC Ferrules:</strong> Precision-machined ferrules for secure and hygienic connections with AJME BPE Certification</li>
          <li><strong>S.S. TC Clamps:</strong> Durable clamps ensuring leak-proof seals in sanitary pipelines.</li>
          <li><strong>S.S. TC Nozzles:</strong> High-precision nozzles ideal for fluid handling systems.</li>
          <li><strong>S.S. Reducers:</strong> Smooth transition reducers for flow consistency between pipe sizes.</li>
        </ul>

        <Card.Text className="mt-2">
          <strong>T.C BLIND_/T.C.END/ DUMMY</strong><br />
          Moc Grande - SS 304/ SS 304L/ SS 316/ SS 316L<br />
          Size - 1/2" To 4", Dn15 To Dn 100<br />
          Outside Diameter - 1/4" N.b To 8"n.b<br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1/4" O.d To 8"o.d<br />
          Standard - 150, DIN, SMS, 3A, BPE
        </Card.Text>
        <Card.Text>
          <strong>SS T.C. CLAMP</strong><br />
          Moc grade - SS 304<br />
          Size - 1/2" to 4" T.C FITTING<br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;DN 10 to DN 100<br />
          Standard - ISO, DIN, SMS, 3A, BPE
        </Card.Text>
        <Card.Text>
          <strong>T.C FERRULE .C NIPPLE</strong><br />
          Moc grade - SS 304/ SS 304L/ SS 316/ SS 316L<br />
          T.C Size - Dia 5mm To 100mm Diameter<br />
          Standard - IDN, ISO, SMS, 3A, BPA
        </Card.Text>
        <Card.Text>
          <strong>BK& BF</strong><br />
          Type – BK/BF 25, BK/BF 30, BK/BF 40<br />
          Shaft Dia - 32mm, 40mm, 50mm<br />
          Axial Load - 7.000, 10.600, 18.000<br />
          Max Speed - 12.000, 7.100, 5.300
        </Card.Text>

      </>
    ),
    images: [
      steelfitting1, steelfitting2, steelfitting3, steelfitting4,

    ]
  },
  {
    title: 'Stainless Steel Strainers & Mesh',
    desc: (
      <>
        <Card.Text>
          Filtration components that enhance product purity and equipment protection in process lines.
        </Card.Text>
        <ul className="mb-0">
          <li><strong>S.S. Strainers:</strong> Available in various mesh grades, ideal for filtering particles and maintaining fluid clarity.</li>
          <li><strong>S.S. Wire Mesh:</strong> Corrosion-resistant wire mesh available in multiple configurations and micron ratings.</li>
        </ul>
        <Card.Text className="mt-2">
          <strong>STAINLESS STEEL WIRE MESH</strong><br />
          MOC: SS 304/ SS 136/ SS 316<br />
          Wire Diameter: 0.02 to 6.30 mm<br />
          Mesh: 1 to 625 Mesh<br />
          Width: Standard Less than 2000 mm<br />
          Length: 30 m Roll / Inter Crimped / Lock / Welded
        </Card.Text>
        <Card.Text>
          <strong>CUSTOMIZED MESH PRODUCTS</strong><br />
          <strong>SILICONE MOLDED SIFTER SIEVE</strong><br />
          MOC: SS 304/ SS 304L/ SS 316 / SS 316L<br />
          Diameter: 50 mm to 1000 mm<br />
          Mesh: 1 to 80 mesh<br />
          Border: Silicon Coated
        </Card.Text>
        <Card.Text>
          <strong>BASKET TYPE FILTER STRAINER</strong><br />
          Mesh: Perforated Sheet & Mesh<br />
          Height: 200 mm to 800 mm<br />
          Size: Dia 100 mm to 500 mm<br />
          MOC: SS 304/ SS 316
        </Card.Text>


      </>
    ),
    images: [
      mesh1, mesh2, mesh3, mesh4

    ]
  },

  {

    title: 'Motion & Load Handling Components',
    desc: (
      <>
        <Card.Text>
          Built for precision motion control and structural support in automation systems and industrial machinery.
        </Card.Text>
        <ul className="mb-0">
          <li><strong>L.M. Guideways:</strong> Linear motion guideways ensuring smooth, accurate movement.</li>
          <li><strong>L.M. Bearings:</strong> Long-lasting bearings built for high-load, high-speed applications.</li>
          <li><strong>Ball Screws & Nuts:</strong> Engineered for repeatable, high-efficiency motion transmission.</li>
          <li><strong>BK/BF Supports:</strong> End supports designed for optimal ball screw alignment and stability.</li>
        </ul>

        <Card.Text className="mt-2">
          <strong>RAIL</strong><br />
          01) Fastering From above<br />
          02) Fasting From Bellow<br />
          Rail Size: Available in 4 Mtr & 6 Mtr<br />
          <strong>SERIES</strong><br />
          HG: 15, 20, 25, 30, 35, 45, 55, 65<br />
          EG: 20, 25<br />
          MGN: 7, 9, 12, 15<br />
          MGW: 12, 15<br />
          COH: 15, 20, 25, 30, 35, 45
        </Card.Text>
        <Card.Text>
          <strong>BLOCK TYPES</strong><br />
          <strong>TYPES</strong> HIGHT RAIL LENGTH<br />
          HGH-CA / HЄН-НА: 28-90 100-4000/6000<br />
          HGL-CA / HGL-HA: 24-70 100-4000/6000<br />
          HGW-CC / HGW-HC: 24-90 100-4000/6000
        </Card.Text>
        <Card.Text>
          <strong>BALL SCREW</strong><br />
          Types: FA/VFA/RMA/RMS<br />
          Screw Diameter: 6 mm to 25 mm<br />
          Lead: 8 mm to 50 mm<br />
          Dynamic Load: 550N to 12800 N
        </Card.Text>
      </>
    ),
    images: [
      motionload1, motionload2, motionload3, motionload4
    ]
  },
  {
    title: 'Caster Wheels',
    desc: (
      <>
        <Card.Text>
          Heavy-duty caster wheels suitable for industrial trolleys, machinery, and material handling systems, providing both mobility and load-bearing efficiency.
        </Card.Text>
        <Card.Text>
          <strong>MEDIUM DUTY CASTER WHEELS</strong><br />
          Caster Type - plate Type, pin/styd Type<br />
          Wheel Type - swlvel, brake, fix<br />
          Size:<br />
          &nbsp;&nbsp;&nbsp;&nbsp;Wheel Diameter 50 To 200mm<br />
          &nbsp;&nbsp;&nbsp;&nbsp;Wheel Width 25 To 50 Mm<br />
          Load Capacity - 30 To 200 Kg On Each Wheel<br />
          Wheel Colors - Red, Blue, Yellow, White, Orange, Green
        </Card.Text>
        <Card.Text>
          <strong>HEAVY DUTY TWIN CSTER WHEEL</strong><br />
          Size:<br />
          &nbsp;&nbsp;&nbsp;&nbsp;1. Diameter:- 50 to 250 mm<br />
          &nbsp;&nbsp;&nbsp;&nbsp;2. Width:- 25 to 50 mm<br />
          Load Capacity - 100 to 600 kg on each wheel
        </Card.Text>
      </>
    ),
    images: [
      wheel1, wheel2, wheel3, wheel4
    ]
  }

];
const products = [
  { image: product1, title: 'Hygienic Stainless Steel Fittings' },
  { image: product2, title: 'Stainless Steel Strainers & Mesh' },
  { image: product3, title: 'Motion & Load Handling Components' },
  { image: product4, title: 'Caster Wheels' },
];


const industries = [
  {
    title: 'Pharmaceutical Manufacturing',
    image: pharmaImg,
    details: `Pharmaceutical Industry
      We understand the strict hygiene, safety, and regulatory standards in pharmaceutical manufacturing. Our components are built for cleanroom compatibility, corrosion resistance, and precision—supporting everything from automated machinery to packaging lines.
  
  What We Offer:
  • Stainless steel mechanical parts
  • Precision-engineered components for process equipment
  • High-performance seals and fittings for sanitary applications
  • Customized precision engineered equipment system`,
  },
  {
    title: 'Industrial Automation Systems',
    image: automationImg,
    details: `Automation Industry
  In the fast-evolving world of industrial automation, precision, reliability, and integration are key. At AIM Industrial Products, we supply advanced mechanical components and systems that seamlessly integrate into automated workflows. Whether it's robotics, assembly lines, or control systems, our solutions are built for performance, repeatability, and longevity in demanding environments.
  
  What We Offer:
  • High-precision mechanical parts for automated machinery
  • Components engineered for robotic arms and motion systems
  • Durable couplings, shafts, and bearings for continuous operation
  • Custom-designed parts for integration into PLC and SCADA-based systems`,
  },
  {
    title: 'Dairy Plants',
    image: dairyImg,
    details: `Dairy Industry
  Dairy processing requires equipment that performs under pressure—literally and figuratively. Our parts are designed for durability, hygiene, and ease of maintenance to ensure minimal downtime and maximum efficiency.
  
  What We Offer:
  • Food-grade stainless steel components
  • CIP (Clean-in-Place) compatible parts
  • Custom mechanical parts for dairy processing systems`,
  },
  {
    title: 'Food Processing Units',
    image: foodImg,
    details: `Food & Beverage Industry
  From processing to packaging, food industry equipment must meet high standards for safety and reliability. AIM provides robust, food-grade components that help keep your lines running smoothly, efficiently, and in full compliance.
  
  What We Offer:
  • FDA-compliant materials
  • Mechanical parts for mixers, conveyors, and filling machines
  • Custom solutions tailored to your production environment`,
  },


];


const reasons = [
  {
    title: "Uncompromising Quality",
    description:
      "Every product is manufactured using premium-grade stainless steel to meet the hygiene and safety standards required in regulated industries.",
    icon: <FaGem className=" me-2" color='#554F23' size={30} />
  },
  {
    title: "Industry Compliance",
    description:
      "Our fittings and components are designed in accordance with applicable standards for pharmaceutical, food, and automation applications.",
    icon: <FaShieldAlt className=" me-2" color='#554F23' size={30} />
  },
  {
    title: "Tailored Solutions",
    description:
      "We offer product customization to meet specific process requirements or design challenges.",
    icon: <FaCogs className="me-2" color='#554F23' size={30} />
  },
  {
    title: "On-Time Delivery",
    description:
      "Streamlined supply chain and reliable logistics ensure prompt delivery across India.",
    icon: <FaTruck className=" me-2" color='#554F23' size={30} />
  },
  {
    title: "Customer Commitment",
    description:
      "Our technical team works closely with clients to ensure the right fit, functionality, and performance.",
    icon: <FaHandsHelping className=" me-2" color='#554F23' size={30} />
  },
];

const images = [
  img1, img2, img12, img13, img3, img4, img5,
  img6, img7, img10,
  img11, img14, img15, img8, img9,
  img16, img17, img18, img19, img20, img21,
  img22, img23, img24, img25, img26, img27,
  img28, img29,
];
const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3
      }
    }
  ]
};

export default function ProductPage() {

  const [activeIndex, setActiveIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const handleViewMore = (industry) => {
    setSelectedIndustry(industry);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  // State for controlling modal visibility and selected image
  const [showImgModal, setShowImgModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Function to handle image click
  const handleImageClick = (imgSrc) => {
    setSelectedImage(imgSrc);
    setShowImgModal(true);
  };

  // Function to close modal
  const handleCloseModal = () => {
    setShowImgModal(false);
    setSelectedImage(null);
  };

  return (
    <>
      <div className="mainnav">

        <Helmet>
          <title>
            Product Range | Hygienic Stainless Steel Fittings, Motion Components & Caster Wheels – AIM
          </title>

          <meta
            name="description"
            content="Explore AIM’s premium product range including hygienic stainless steel fittings, precision motion components, and heavy-duty caster wheels – designed for performance and purity."
          />
          <meta
            name="keywords"
            content="stainless steel fittings, hygienic fittings, CIP fittings, TC ferrules, TC clamps, TC nozzles, TC reducers, SS strainers, caster wheels, load handling components, motion components, BK BF bearings, pharmaceutical components"
          />
          <meta name="author" content="AIM Industrial Products" />
          <meta name="robots" content="index, follow" />

          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content="Premium Product Range | AIM Industrial Products"
          />
          <meta
            property="og:description"
            content="From hygienic stainless steel fittings to load-handling and motion components, AIM delivers solutions built for regulated industries like pharma, dairy, and food."
          />
          <meta
            property="og:image"
            content="https://aimindproducts.com/assets/products-banner.jpg" // Replace with actual image
          />
          <meta property="og:url" content="https://aimindproducts.com/products" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="AIM Product Range | Stainless Steel Components & Motion Systems"
          />
          <meta
            name="twitter:description"
            content="Discover high-performance, industry-compliant products including stainless steel TC fittings, BK/BF bearing blocks, caster wheels, and more."
          />
          <meta
            name="twitter:image"
            content="https://aimindproducts.com/assets/products-banner.jpg" // Replace with actual product image
          />

          {/* Canonical URL */}
          <link rel="canonical" href="https://aimindproducts.com/products" />
        </Helmet>

        {/* Banner Section */}
        <div className="about-banner position-relative text-white mb-4">
          <img
            src={productbanner}
            alt="About Banner"
            className="aboutbanner-image animate-banner-zoom"
          />
          <div className="maindesc position-absolute top-50 start-50 translate-middle  px-1">
            <h2 className="fw-bold " >
              Explore Our Premium Product
            </h2>
            <p className="lead">
              From hygienic fittings to precision motion components and heavy-duty caster wheels — discover solutions designed for performance, purity, and durability.
            </p>
          </div>
        </div>


        <Container className="mb-2">
          <h2 className="Mainhead ">Our Product Range</h2>
          <Container className="py-4">
            <Row>
              {products.map((product, index) => (
                <Col key={index} md={3} sm={6} xs={12} className="mb-3">
                  <Card className="h-100 orgproduct shadow-sm">
                    <Card.Img variant="top" src={product.image} style={{ height: '200px', objectFit: 'cover' }} />
                    <Card.Body>
                      <h5 className="text-center fs-6">{product.title}</h5>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>

          <Container className="py-4 ">
            <Row className="justify-content-center">
              <Col md={11} className="productcard rounded-4 p-0">
                <Row className="g-3">
                  {/* Left Column (Titles) */}
                  <Col
                    md={4}
                    className="px-4  bg-white"
                    style={{

                      borderTopLeftRadius: '16px',
                      borderBottomLeftRadius: '16px',
                    }}
                  >
                    <div
                      className="p-3 rounded-3"
                    >
                      {sections.map((section, idx) => (
                        <Button
                          key={idx}
                          variant="light"
                          className={`w-100 text-start mb-3 rounded-3 text-center fw-semibold fs-6 title-button ${idx === activeIndex ? 'active-title' : ''
                            }`}
                          onClick={() => setActiveIndex(idx)}
                        >
                          {section.title}
                        </Button>
                      ))}
                    </div>
                  </Col>

                  {/* Right Column (Content) */}
                  <Col
                    md={8}
                    className="p-4 bg-white productrightcard"
                    style={{
                      borderTopRightRadius: '16px',
                      borderBottomRightRadius: '16px',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
                      height:'500px',
                      overflowY:'auto',
                    }}
                  >
                    <Card className="border-0">
                      <h4 className='text-center' style={{ color: '#14234C', fontWeight: 'bold' }}>{sections[activeIndex].title}</h4>
                      <Card.Body>{sections[activeIndex].desc}</Card.Body>
                    </Card>
                    <Row className="mt-3 ">
                      {sections[activeIndex].images?.map((imgSrc, i) => (
                        <Col xs={6} md={6} lg={3} className="mb-3" key={i}>
                          <img
                            src={imgSrc}
                            alt={`Section ${activeIndex} ${i}`}
                            className="img-fluid rounded"
                            onClick={() => handleImageClick(imgSrc)}
                          />
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
          <Modal show={showImgModal} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <img
                src={selectedImage}
                alt="Selected Preview"
                className="img-fluid"
              />
            </Modal.Body>
          </Modal>

          {/* New section */}

          {/* <Container className='mt-4'>
            <Row className='m-0'>
              <Col>
                <h2 className="Mainhead">We also deal with Products</h2>
                <div className='newproducts'>
                  <h4>
                    1.We also deal in spares parts used for automatic CNC Griending machine
                  </h4>
                  <h4>
                    2.manufacturing all types of ss casting
                  </h4>
                </div>
                <Slider {...settings}>
                  {images.map((img, index) => (
                    <div key={index}>
                      <img src={img} alt={`product-${index}`}
                        style={{ width: "100%", height: "auto", padding: "10px", borderRadius: '20px' }} />
                    </div>
                  ))}
                </Slider>
              </Col>
            </Row>
          </Container> */}

<div className="product-section mt-4 ">
      <Container className='py-4'>
        <Row className='m-0 justify-content-center'>
          <Col md={10} className="text-center">
            <h2 className="Mainhead mb-4">We Also Deal With Products</h2>
            <div className='newproducts mb-5'>
              <h5 className='product-line  '><FaCogs className='dealicon' /> We also deal in spare parts used for automatic CNC Grinding Machines</h5>
              <h5 className='product-line'><FaIndustry className='dealicon' /> Manufacturing all types of SS castings</h5>
            </div>
            <Slider {...settings}>
              {images.map((img, index) => (
                <div key={index} className="slider-item">
                  <img src={img} alt={`product-${index}`} className="slider-image" />
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
    </div>


          <Container className="my-5">
            <h2 className="Mainhead">Why Choose AIM Industrial Products?</h2>
            <Row className="g-4 mt-3">
              {reasons.map((item, index) => (
                <Col md={6} lg={4} key={index}>
                  <Card className="h-100 shadow-lg border-0 rounded-4 hover-card">
                    <Card.Body>
                      <Row className="align-items-start">
                        <Col xs={2} className="position-relative icon-wrapper">
                          <div className="iconproduct">{item.icon}</div>
                        </Col>
                        <Col xs={10}>
                          <Card.Title className="fw-semibold mb-1">{item.title}</Card.Title>
                          <Card.Text className="text-muted mb-0" >
                            {item.description}
                          </Card.Text>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>

          <Container className="mt-5">
            <h2 className="Mainhead">Industries We Serve</h2>
            <Row className="mt-5">
              {industries.map((industry, idx) => (
                <Col key={idx} md={3} sm={6} xs={12} className="mb-4">
                  <Card className="h-100 orgproduct shadow-sm">
                    <Card.Img variant="top" src={industry.image} style={{ height: '200px', objectFit: 'cover' }} />
                    <Card.Body className="d-flex flex-column ">
                      <Card.Title className="text-center fs-6">{industry.title}</Card.Title>
                      <Button className='productview m-auto' onClick={() => handleViewMore(industry)}>
                        View More
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>

          <Modal show={showModal} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <Row className="">
                <Col xs={12} md={4} className="text-center">
                  <img
                    src={selectedIndustry?.image}
                    alt={selectedIndustry?.title}
                    className="mb-3"
                    style={{
                      width: '100%',
                      height: '250px',
                      objectFit: 'cover',
                      borderRadius: '8px'
                    }}
                  />
                </Col>
                <Col xs={12} md={8}>
                  <h4 className="fw-bold mb-2 text-center " style={{ color: '#14234C' }}>
                    {selectedIndustry?.title}
                  </h4>
                  <div style={{ whiteSpace: 'pre-line' }}>{selectedIndustry?.details}</div>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </Container>
      </div>

    </>
  );
}
